import comp from "./DotLoadingIcon";
export default comp;
